import React from 'react';
import { IRollingControl } from '../../../../utils/apollo/graphqlSchema';
import RollingControlValueField from './RollingControlValueField';
import {
  builderSetRollingControl,
  IRowMeta,
} from '../../../../redux/slices/oldBuilder';
import { useAppDispatch } from '../../../../redux/hooks';
import * as BuilderUI from '../../BuilderUI';
import { rollingControlLabelLookup } from '../../../../utils/builder/rollingControl';
import { SquareRemoveButton } from '../../../Button';

interface IProps {
  rowMeta: IRowMeta;
  measureRollingControl: IRollingControl;
}

const RollingControl = ({ rowMeta, measureRollingControl }: IProps) => {
  const dispatch = useAppDispatch();

  const handleChangeRollingValue = (window: number) => {
    dispatch(
      builderSetRollingControl({
        rowMeta,
        value: {
          ...measureRollingControl,
          window,
        },
      }),
    );
  };

  const handleRemove = () => {
    dispatch(
      builderSetRollingControl({
        rowMeta,
        value: null,
      }),
    );
  };

  const rollingWindowValue =
    measureRollingControl.window > 0
      ? measureRollingControl.window.toString()
      : null;

  return (
    <BuilderUI.BuilderFieldContainer>
      <BuilderUI.BuilderFieldLabel>
        {rollingControlLabelLookup[measureRollingControl.function]}
      </BuilderUI.BuilderFieldLabel>
      <RollingControlValueField
        value={rollingWindowValue}
        onChange={handleChangeRollingValue}
        autoFocus={!rollingWindowValue}
      />
      <SquareRemoveButton
        onClick={handleRemove}
        content={'Remove rolling control.'}
      />
    </BuilderUI.BuilderFieldContainer>
  );
};

export default RollingControl;
